import React, { FunctionComponent } from "react";
import { useHistory } from "react-router-dom";
import { NamedProperty, CodedProperty, BreadcrumbItem, Breadcrumb } from "sprint-common-web";

import { AncillaryContentSubtype } from "../../../../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { assetsSearchRoutes, getAncillaryAssetsListHref, getAssetsSearchPageHref } from "../../../../AssetsRoutes";

interface AncillaryDetailsPageBreadcrumbsProps {
    contentType: AncillaryContentSubtype;
    ancillary: NamedProperty;
    airline: CodedProperty;
}

export const AncillaryDetailsPageBreadcrumbs: FunctionComponent<AncillaryDetailsPageBreadcrumbsProps> = (
    props: AncillaryDetailsPageBreadcrumbsProps
) => {
    const history = useHistory();

    const { contentType, ancillary, airline } = props;

    const goToAssetsSearchPage = () => {
        const href = getAssetsSearchPageHref(contentType);
        history.push(href);
    };

    const goToAncillaryAssetsList = (ancillaryId: string, airlineId?: string) => {
        const airlineIds = airlineId ? [airlineId] : [];

        const href = getAncillaryAssetsListHref(ancillaryId, airlineIds);
        history.push(href);
    };

    const items: BreadcrumbItem[] = [
        ...assetsSearchRoutes.baseRouteNames.map((name: string) => {
            return { key: name, text: name };
        }),
        {
            key: "search-ancillary-breadcrumb",
            text: resolveContentTypeName(contentType),
            onClick: goToAssetsSearchPage
        },
        {
            key: "ancillary-assets-list-breadcrumb",
            text: `${airline.code} - ${ancillary.name}`,
            onClick: () => goToAncillaryAssetsList(ancillary.id, airline.id)
        }
    ];

    return <Breadcrumb items={items} />;
};

const resolveContentTypeName = (contentType: AncillaryContentSubtype) => {
    switch (contentType) {
        case ContentSubtype.Advert:
            return "Adverts";

        case ContentSubtype.Promo:
            return "Promos";

        case ContentSubtype.Safety:
            return "Safeties";

        case ContentSubtype.IndentWarning:
            return "Indent Warnings";

        case ContentSubtype.ClientSpecific:
            return "Client Specific";

        default:
            throw new Error(`'${contentType}' is not ancillary content type.`);
    }
};
